/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Hero_DetectedInputs */

const en_wc_hero_detected = /** @type {(inputs: Wc_Hero_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected`)
};

/**
* | output |
* | --- |
* | "Detected" |
*
* @param {Wc_Hero_DetectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_hero_detected = /** @type {((inputs?: Wc_Hero_DetectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Hero_DetectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_hero_detected(inputs)
});
export { wc_hero_detected as "wc.hero.detected" }